import { IconDefinition, faHome } from "@fortawesome/free-solid-svg-icons";
import { RoutePattern } from "../../routes/RoutePattern";

export interface RouteTypes {
  name: string;
  to?: string;
  linked?: string;
  smooth?: boolean;
  isAnchor?: boolean;
  dropdown?: RouteTypes[];
  self?: string;
  nextTo?: string;
}

export const data: RouteTypes[] = [
  {
    name: "home",
    smooth: true,
  },
  {
    name: RoutePattern.MUSIC,
    smooth: true,
  },
  {
    name: RoutePattern.VIDEOS,
    smooth: true,
  },
  {
    name: RoutePattern.TOUR,
    smooth: true,
  },
  {
    name: "shop",
    linked: "https://christiansexclub.com/",
    isAnchor: true,
  },
];

function removeHyphen(str: string) {
  return str.replace(/\-/g, " ");
}
